const TOKEN = "TOKEN";
const DATAIDLIST = "DATAIDLIST";
const THEME = "THEME";

export function getToken() {
  // return localStorage.getItem(TOKEN);
  return sessionStorage.getItem(TOKEN);
}

export function setToken(value) {
  // return localStorage.setItem(TOKEN, value);
  return sessionStorage.setItem(TOKEN, value);
}

export function setIdList(value) {
  return localStorage.setItem(DATAIDLIST, value);
}

export function getIdList() {
  return localStorage.getItem(DATAIDLIST);
}

export function setTheme(value) {
  return localStorage.setItem(THEME, JSON.stringify(value));
}

export function getTheme() {
  return JSON.parse(localStorage.getItem(THEME));
}
